import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=44641384&scoped=true"
var script = {}
import style0 from "./Placeholder.vue?vue&type=style&index=0&id=44641384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44641384",
  null
  
)

export default component.exports